import { Route } from "react-router-dom";
import { Footer } from "../Footer/footer";
import { Header } from "../Header/header";
import { Login } from "../Login/Login";
import { PartnerLogin } from "./PartnerLogin";
import { DataProvider } from "../../Context/DataContext";
import { AuthProvider } from "../../Context/AuthContext";
import PreparePartner from "./PreparePartner";

export const PartnerRoutes = [
    <Route path="/partner/start" element={
        <>
        <AuthProvider>
          <Header />
          <PartnerLogin />
          <Footer />
        </AuthProvider>
        </>
        
      }>
    </Route>,
    <Route path="/partner/prepare" element={
      <>
      <AuthProvider>
      <DataProvider>
        <Header />
        <PreparePartner />
        <Footer />
      </DataProvider>
      </AuthProvider>
      </>
      
    }>
  </Route>
]